import {
  createChargeCode,
  updateChargeCode,
  chargeCodeTemplate,
  getChargeCode,
  chageCodeList,
  chageCodeListDelete,
} from "@/http/chargeCode";
import { taxMappingTemplate } from "@/http/taxmap";

export default {
  namespaced: true,
  state: {
    list: [],
    template: {},
    taxTemplate: {},
    chargeCodeById: {},
  },
  actions: {
    async setEntities({ commit }) {
      try {
        const resp = await chageCodeList();
        commit("SET_ENTITIES", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteChargeCodeAction(_, payload) {
      try {
        return await chageCodeListDelete(payload);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createChargeCodeAction(_, data) {
      try {
        return await createChargeCode(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateChargeCodeAction(_, data) {
      try {
        return await updateChargeCode(data.id, data.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setFormTemplate({ commit }) {
      try {
        const resp = await chargeCodeTemplate();
        commit("SET_FORM_TEMPLATE", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setChargeCodeData({ commit }, id) {
      const resp = await getChargeCode(id);
      commit("SET_CHARGE_CODE_DATA", resp.data);
      return resp;
    },
    async setTaxTemplate({ commit }, data) {
      const resp = await taxMappingTemplate(data);
      commit("SET_TAX_TEMPLATE", resp.data);
      return resp;
    },
  },
  mutations: {
    SET_ENTITIES(state, payload) {
      state.list = payload;
    },
    SET_FORM_TEMPLATE(state, payload) {
      state.template = payload;
    },
    SET_TAX_TEMPLATE(state, payload) {
      state.taxTemplate = payload;
    },
    SET_CHARGE_CODE_DATA(state, payload) {
      state.chargeCodeById = payload;
    },
  },
  getters: {
    getEntityList(state) {
      return state.list;
    },
    getFormTemplate(state) {
      return state.template;
    },
    getTaxTemplate(state) {
      return state.taxTemplate;
    },
    getChargeCode(state) {
      return state.chargeCodeById;
    },
  },
};
